import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  projectID: null,
  processID: null,
  name: '',
};

const pertaminaGrianaProject = createSlice({
  name: 'LI/pertamina/griana-project',
  initialState,
  reducers: {
    setProjectDetail(state, action) {
      const { payload } = action;
      state.projectID = payload.projectID;
      state.processID = payload.processID;
      state.name = payload.name;
    }
  }
});

export const {
  reducer: grianaProjectReducer,
  actions: grianaProjectActions,
} = pertaminaGrianaProject;
